import { BootResponse } from '../constants/apiResponses.types';
import { EFeatureFlag } from '../constants/enums';
import { decodeAndSanitizeBase64Html } from './sanitizeHtml';

export interface MaintenanceModeState {
  isActive: boolean;
  sanitizedHtml: string;
  fontColor?: string;
  fontFamily?: string;
  logo?: string;
  backgroundImageMobile?: string;
  backgroundImageDesktop?: string;
}

export const getMaintenanceModeState = (
  publisherMetaData?: BootResponse | null
): MaintenanceModeState => {
  const featureFlag = Boolean(
    publisherMetaData?.featureFlags?.[EFeatureFlag.STORE_MAINTENANCE_MODE_SETTINGS]
  );
  const general = publisherMetaData?.storeTheme?.general;
  const maintenanceConfig = general?.maintenanceModeRichText;
  const base64Text = maintenanceConfig?.text;

  const sanitizedHtml = base64Text?.trim()
    ? decodeAndSanitizeBase64Html(base64Text)
    : '';
  const isActive = Boolean(featureFlag);

  return {
    isActive,
    sanitizedHtml,
    fontColor: maintenanceConfig?.fontColor,
    fontFamily: general?.font,
    logo: general?.logo,
    backgroundImageMobile: general?.backgroundImageMobile,
    backgroundImageDesktop: general?.backgroundImageDesktop,
  };
};
